import React, { Component } from "react";
import Functions from "../../src/functions";
import { FileDrop } from "react-file-drop";
import "./style.css";
import axios from "axios";

/*
file object

{
url:"",
status:"pending|completed|normal",
progress:100
}
*/

class Upload extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    files: [],
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.editable = this.editable.bind(this);
    this.nonEditable = this.nonEditable.bind(this);
    this.customUI = this.customUI.bind(this);

    this.onFrameDragEnter = function () { };
    this.onFrameDragLeave = function () { };
    this.onFrameDrop = function () { };
    this.onDragOver = function () { };
    this.onDragLeave = function () { };
    this.getExtension = this.getExtension.bind(this);
    this.previewFile = this.previewFile.bind(this);
    this.cancelClick = this.cancelClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onFileInputChange = this.onFileInputChange.bind(this);
    this.onTargetClick = this.onTargetClick.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    this.state = {
      events: events,
      previewImageExtensions: ["png", "jpg", "jpeg", "gif"],
      previewVideoExtensions: ["mp4", "avi"],
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
    };
  }

  componentDidMount() {
    this.setState({
      attributes: this.props.property.attributes,
      configuration: this.props.property.configuration,
      name: this.props.property.alias,
      loaded: true,
      files: this.props.property.configuration.formatInputValue
        ? this.props.property.configuration.formatInputValue(this.props.value)
        : [],
      fileInputRef: React.createRef(),
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  getExtension(file) {
    return file.split(/[#?]/)[0].split(".").pop().trim().toLowerCase();
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  onDrop(files, event) {
    let _this = this;
    let filesArray = [];
    let filesLenght = this.state.files.length + Array.from(files).length;

    if (this.state.configuration.maxFilesCount) {
      if (filesLenght > this.state.configuration.maxFilesCount) {
        Functions.createAlert({
          type: "danger",
          message:
            "You have reached the maximum number of files ('" +
            this.state.configuration.maxFilesCount +
            "').",
        });
        return;
      }
    }

    if (this.state.configuration.mimeTypes) {
      Array.from(files).forEach((file, idx) => {
        if (this.state.configuration.mimeTypes.indexOf(file.type) >= 0) {
          filesArray.push(file);
        } else {
          Functions.createAlert({
            type: "danger",
            message:
              "The file '" + file.name + "' has not an allowable mime type",
          });
        }
      });
    } else {
      filesArray = Array.from(files);
    }

    filesArray.forEach((file, idx) => {
      setTimeout(function () {
        let fileUUID = Functions.key();
        let cancelToken = axios.CancelToken.source();

        let fileObject = {
          url: URL.createObjectURL(file),
          status: "pending",
          progress: 0,
          uuid: fileUUID,
          cancelToken: cancelToken,
        };

        _this.setState({ files: [..._this.state.files, fileObject] });

        let postData = null;

        if (_this.state.configuration.postData) {
          postData = new _this.state.configuration.postData(file, event);
        } else {
          postData = new FormData();
          postData.set("file", file);
        }

        Functions.REST({
          api: _this.state.configuration.api,
          component: _this,
          postData: postData,
          cancelToken: cancelToken.token,
          onUploadProgress: function (p) {
            let updatedFiles = [];

            _this.state.files.forEach((itm, idx) => {
              if (itm.uuid == fileUUID) {
                itm.progress = Math.round((100 * p.loaded) / p.total);
              }
              updatedFiles.push(itm);
            });

            _this.setState({ files: _this.state.files });
          },
          callback: function (data, status, response, error, component) {
            let updatedFiles = [];

            _this.state.files.forEach((itm, idx) => {
              if (itm.uuid == fileUUID) {
                if (_this.state.configuration.callbackDataItem) {
                  itm = _this.state.configuration.callbackDataItem(data, itm);
                }
                itm.status = "completed";
              }

              updatedFiles.push(itm);
            });

            _this.setState({ files: _this.state.files });
          },
        });
      });
    }, 100);
  }

  onFileInputChange = (event) => {
    const { files } = event.target;
    this.onDrop(files, event);
  };

  previewFile(file) {
    let ext = this.getExtension(file);

    if (this.state.previewImageExtensions.indexOf(ext) >= 0) {
      window["modal2"].setState({
        show: true,
        size: "xl",
        body: (
          <div className="text-center">
            <img src={file} className="img-fluid"></img>
          </div>
        ),
      });
    }
    if (this.state.previewVideoExtensions.indexOf(ext) >= 0) {
      window["modal2"].setState({
        show: true,
        size: "xl",
        body: (
          <div className="text-center">
            <video controls>
              <source src={file} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ),
      });
    }
  }

  onTargetClick = () => {
    this.state.fileInputRef.current.click();
  };

  cancelClick(fileUUID) {
    let updatedFiles = [];

    this.state.files.forEach((itm, idx) => {
      if (itm.uuid === fileUUID) {
        if (itm.cancelToken) {
          itm.cancelToken.cancel();
        }
      } else {
        updatedFiles.push(itm);
      }
    });

    this.setState({ files: updatedFiles });
  }

  editable() {
    let control = (
      <div>
        <FileDrop
          onFrameDragEnter={(event) => this.onFrameDragEnter(event)}
          onFrameDragLeave={(event) => this.onFrameDragLeave(event)}
          onFrameDrop={(event) => this.onFrameDrop(event)}
          onDragOver={(event) => this.onDragOver(event)}
          onDragLeave={(event) => this.onDragLeave(event)}
          onDrop={(files, event) => this.onDrop(files, event)}
        //   className={
        //     this.state.attributes ? this.state.attributes["className"] : ""
        //   }
        >
          {this.state.files.map((itm, idx) => {
            return (
              <div className="d-inline-block position-relative m-2 rect-drop-wrapper">
                <img
                  src={itm.url}
                  className={"rounded pointer img-thumbnail  m-2 " + itm.status}
                  onClick={(e) =>
                    itm.status !== "pending"
                      ? this.previewFile(itm.url)
                      : undefined
                  }
                ></img>
                <div className="inner-contents w-100 pl-4 pr-4 mt-2">
                  <div className="input-group pt-1">
                    {itm.status === "pending" ? (
                      <div className="progress w-75">
                        <div
                          className="progress-bar progress-bar-striped active"
                          role="progressbar"
                          style={{ width: itm.progress + "%" }}
                          aria-valuenow={itm.progress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {itm.progress}%
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <span
                      className="ml-1 bg-light pointer choices"
                      onClick={(e) => this.cancelClick(itm.uuid)}
                    >
                      {itm.status === "pending" ? "Cancel" : "Remove"}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
          {this.state.files.length == 0 ? (
            <div className="text-center p-3">
              <strong>There are no files</strong>
              <span className="d-block">
                Upload a{" "}
                <span
                  className="text-primary pointer"
                  onClick={this.onTargetClick}
                >
                  file
                </span>{" "}
                or drag and drop here
              </span>
            </div>
          ) : (
            ""
          )}
        </FileDrop>
        <input
          onChange={this.onFileInputChange}
          ref={this.state.fileInputRef}
          onClick={(event) => {
            event.target.value = null;
          }}
          type="file"
          style={{ display: "none" }}
          accept={
            this.state.configuration.mimeTypes
              ? this.state.configuration.mimeTypes.join(",")
              : "*"
          }
          multiple
        />
        <input
          type="hidden"
          defaultValue={
            this.state.configuration.formatOutputValue
              ? this.state.configuration.formatOutputValue(this.state.files)
              : JSON.stringify(this.state.files)
          }
          name={this.state.name}
          {...this.state.attributes}
        ></input>
      </div>
    );

    return this.customUI(control);
  }

  nonEditable() {
    let control = [];

    {
      this.state.files.map((itm, idx) => {
        control.push(
          <div className="d-inline-block position-relative m-2 rect-drop-wrapper">
            <img
              src={itm.url}
              className={"rounded pointer img-thumbnail  m-2 "}
              onClick={(e) => this.previewFile(itm.url)}
            ></img>
          </div>
        );
      });
    }

    return this.customUI(control);
  }

  render() {
    if (this.state.loaded) {
      let control = this.state.editable ? this.editable() : this.nonEditable();

      return control;
    }
    return "";
  }
}

export default Upload;
